import { IonButton, IonImg } from "@ionic/react";
import { useHistory } from "react-router";
import AngleImg from "../../assets/images/angle.png";
import { useEffect, useState } from "react";
import { ASSESSMENT_STATUSES } from "../../movenet/params";

interface Props {
  setCalibrationError: Function;
  angleValue?: number;
}
const CalibrationErrorModal: React.FC<Props> = ({
  setCalibrationError,
  angleValue,
}) => {
  let history = useHistory();

  const [sliderValue, setsliderValue] = useState(0);
  const [angleOk, setAngleOk] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    if ((angleValue as number) >= 88 && (angleValue as number) <= 92) {
      setAngleOk(true);
      setIsDisabled(false);
    } else {
      setAngleOk(false);
      setIsDisabled(true);
    }

    let calculateValue = (((angleValue as number) * 2) / 360) * 100 - 2;
    setsliderValue(calculateValue);
  }, [angleValue]);

  // const recalibration = () => {
  //   const counter = sessionStorage.getItem("retry-counter");
  //   if (counter)
  //     sessionStorage.setItem("retry-counter", (Number(counter) + 1).toString());
  //   setCalibrationError(false);
  //   history.replace("/angle-adjustment");
  // };

  const Continue = () => {
    ASSESSMENT_STATUSES.calibration_error_state = false;
    setCalibrationError(false);
  };

  return (
    <>
      <div className="calibration-error-modal">
        <div className="align-center">
          <h1 className="assesment-modal-label mb-0">Angle Calibration</h1>
          {/* <p className="calibration-modal-desc">
            The phone’s position has moved. <br></br> Restart the assessment and
            recalibrate the phone to continue.
          </p>
          <IonButton
            placeholder={undefined}
            className="blue-btn"
            onClick={() => {
              recalibration();
            }}
          >
            Recalibrate & Retry
          </IonButton> */}

          <div className="angle-adjustment-wrap">
            <div className="range-slider-custom">
              {/* ( angle-active )class add after range-slider-custom-inner-sec  */}

              <div
                className={`range-slider-custom-inner-sec ${
                  angleOk ? "angle-active" : ""
                }`}
              >
                <span className="one"></span>
                <span className="two" style={{ top: sliderValue + "%" }}></span>
              </div>
            </div>

            <IonImg
              src={AngleImg}
              className="angle-img"
              placeholder={undefined}
            ></IonImg>
          </div>

          <IonButton
            disabled={isDisabled}
            placeholder={undefined}
            className="blue-btn"
            onClick={Continue}
          >
            Continue
          </IonButton>
        </div>
      </div>
    </>
  );
};
export default CalibrationErrorModal;
